// c:\Data\Fullstack\MyProjects\invest-ai\invest_FE\src\components\error\ErrorFallback.js
import React, { useEffect, useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import { reportError } from '../../utils/errorReporter';
import './ErrorFallback.css';

function ErrorFallback({ error, resetErrorBoundary, componentStack }) {
  const { user } = useContext(UserContext);

  useEffect(() => {
    // The componentStack is sometimes passed by error boundaries.
    // We'll create the errorInfo object expected by our reporter.
    const errorInfo = { componentStack };
    reportError(error, errorInfo, user);
    // We only want this to run once when the error boundary mounts.
  }, [error, componentStack, user]);

  return (
    <div className="error-container" role="alert">
      <div className="error-content">
        <h2>Oops! Something went wrong.</h2>
        <p>We are sorry for the inconvenience. The error has been reported to our team.</p>
        <p>Please try refreshing the page, or click the button below to try to recover.</p>
        <button onClick={resetErrorBoundary}>Try Again</button>
        {/* It's a good practice to only show error details in development */}
        {process.env.NODE_ENV === 'development' && (
          <details className="error-details">
            <summary>Error Details</summary>
            <pre>
              {error.name}: {error.message}
              {`\n${error.stack}`}
            </pre>
          </details>
        )}
      </div>
    </div>
  );
}

export default ErrorFallback;
